import React from "react";
import "../../styles/product/QuantitySelector.css";

interface QuantitySelectorProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  onMaxReached?: (max: number) => void;
  disabled?: boolean;
}

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  value,
  onChange,
  min = 1,
  max,
  onMaxReached,
  disabled = false,
}) => {
  const handleDecrement = () => onChange(Math.max(min, value - 1));
  const handleIncrement = () => {
    if (typeof max === "number" && value >= max) {
      onMaxReached?.(max);
      return;
    }

    onChange(typeof max === "number" ? Math.min(max, value + 1) : value + 1);
  };

  return (
    <div className="quantity-selector">
      <button type="button" disabled={disabled} onClick={handleDecrement}>
        -
      </button>
      <span>{value}</span>
      <button type="button" disabled={disabled} onClick={handleIncrement}>
        +
      </button>
    </div>
  );
};

export default QuantitySelector;
